import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';

import { store } from 'index';
import { componentsStateType } from 'reducer/types';
import { pageStateType } from 'types';
import { SET_COMPONENTS_STATE } from 'actions/componentsActions';
import { SET_PAGE_STATE } from 'actions/pageActions';

/**
 * No history.listen() here → avoids "only one active listener".
 * Uses Router v6 hooks to react to POP events.
 */
export default function useBackListener() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const navType   = useNavigationType(); // 'POP' | 'PUSH' | 'REPLACE'

  const dispatchers = useMemo(() => ({
    setComponentsState(payload: componentsStateType) {
      store.dispatch(SET_COMPONENTS_STATE(payload));
    },
    setPageState(payload: pageStateType) {
      store.dispatch(SET_PAGE_STATE(payload));
    },
  }), []);

  useEffect(() => {
    if (navType !== 'POP') return; // handle real back/forward only

    const state           = store.getState();
    const pageState       = state.page as pageStateType;
    const componentsState = state.components as componentsStateType;

    if ((location as any)?.pathname === '/') {
      try { navigate(-1); } catch {}
    }

    const { showAppIframe } = componentsState;
    const appPage = pageState.page === 'app page' || !!showAppIframe;

    dispatchers.setComponentsState({
      ...componentsState,
      sender:        'useBackListener',
      showAppIntro:  false,
      showMenu:      true,
      showNavBar:    true,
      showAppIframe: false,
      appUrl:        '',
    });

    if (appPage) {
      dispatchers.setPageState({ ...pageState, page: pageState.savedPage });
    }

    try { navigate('../'); } catch {}
  }, [navType, location.key, navigate, dispatchers, location]);
}
